import { fade } from '@material-ui/core'

const styles = theme => ({
  root: {
    position: 'fixed',
    display: 'flex',
    justifyContent: 'center',
    backgroundColor: fade(theme.palette.white, 0.8),
    padding: theme.spacing(8, 2),
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: theme.zIndex.loader,
    [theme.breakpoints.up('sm')]: {
      padding: theme.spacing(12, 4),
    },
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  progress: {
    marginBottom: theme.spacing(2),
  },
})

export default styles
